// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__7_nP4","title":"Info_title__1uSPk","links":"Info_links__36ZB6","link":"Info_link__3qwoD","logo":"Info_logo__1z6cD"};